import { useParams } from 'wouter';

import useCollection from '../../hooks/useCollection';
import { useCollectionSchemas } from '../../hooks/useMicroformats';
import { useCollectionUrlGenerator } from '../../hooks/useUrlGenerator';

import Metadata from './Metadata';
import NotfoundMetadata from './NotfoundMetadata';

function CollectionMetadata() {
    const { slug: slugParam = null } = useParams<{ slug?: string }>();
    const { collection = null, notFound = false } = useCollection(slugParam);
    const collectionUrl = useCollectionUrlGenerator();
    const schemas = useCollectionSchemas(collection);

    if (notFound) {
        return <NotfoundMetadata />;
    }

    if (collection === null) {
        return null;
    }

    const { type, title, slug, metadata, image } = collection;
    const { description, brands, keywords } = metadata || {};
    const [brand = null] = brands || [];

    return (
        <Metadata
            brand={brand}
            title={title}
            description={description}
            keywords={keywords}
            image={image}
            url={collectionUrl({
                type,
                slug,
            })}
            document={collection}
            pageType={type}
            microformats={schemas}
        />
    );
}

export default CollectionMetadata;
